<template>
    <div>
        <!-- 过滤条件 -->
        <div
            :class="preCls + 'filter'"
            style="display: flex; align-items: center; margin-bottom: 4px"
        >
            <form-lookup
                style="
                    min-width: 262px;
                    margin-right: 15px;
                    max-height: 90px;
                    overflow: auto;
                "
                v-model="selectRoom.roomId"
                :options.sync="selectRoom.roomList"
                placeholder="房源名称"
                title="选择房间"
                textSymbol="title"
                valueSymbol="id"
                :modalHeight="600"
                :modalWidth="900"
                @change="onSelectRoom"
                @clear="onClearRoom"
                @deselect="onDeselectRoom"
            >
                <select-room multiple />
            </form-lookup>
            <!-- 选择排序 -->
            <Select
                style="width: 200px; margin-right: 15px"
                v-model="filter.orderBys"
                placeholder="排序类型"
                @on-change="search"
            >
                <Option
                    v-for="item in orderBysList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <!-- 高级搜索 -->
            <c-adv-search
                ref="adv"
                v-model="advFilter"
                :name="accessName"
                @confirm="onAdvConfirm"
            ></c-adv-search>
        </div>
        <!-- 已选中的搜索条件 -->
        <select-tags
            v-model="advOptions"
            style="margin-bottom: 4px"
            @close="onAdvItemClose"
        ></select-tags>
        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    v-model="filter.cusUser"
                    placeholder="请输入客户姓名,手机号或单位名称"
                    style="margin-left: 10px"
                    @search="search"
                ></table-searcher>
            </template>
            <Button
                :class="preCls + 'button-margin'"
                v-if="false && $can('add')"
                :disabled="loading"
                type="primary"
                @click="onClickAdd"
            >
                录入合同
            </Button>
            <Button
                v-if="$can('exportExcel')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                :loading="loadingExport"
                @click="onClickExport"
            >
                导出Excel
            </Button>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <template v-slot:contractStatusText="{ row }">
                <tag-status
                    :text="row.contractStatusText"
                    :color="row.contractStatusColor"
                    :background="row.contractStatusBgc"
                    circle
                />
            </template>
            <template v-slot:migrateTypeText="{ row }">
                <tag-status
                    v-if="row.migrateTypeText"
                    :text="row.migrateTypeText"
                    :color="row.migrateTypeColor"
                    :background="row.migrateTypeBgc"
                    circle
                />
            </template>
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    v-if="
                        $can('view', 'api/contract/view/detail') ||
                        $can('view', 'api/contract/view/bill')
                    "
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickInfo(row)"
                >
                    详情
                </Button>
                <Button
                    v-if="row.isLiquation && $can('liquidation')"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="rowClickLiquidationDetail(row)"
                >
                    清算明细
                </Button>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        ></table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showChargeDetails"
            title="清算明细"
            :width="800"
            :height="600"
            :maskClosable="false"
        >
            <charge-details
                v-if="modal.showChargeDetails"
                :value="chargeDetails"
                :remark="remark"
                history
            />
        </smart-modal>
    </div>
</template>
<script>
import { mapCache } from '@/plugins/vux-data-cache'
import { pipeCell } from '_c/grid/renderCell'
import { currency } from '_u/helper'
import Dict from '_u/dict'

import mContractList from '_v/common/m-contract-list'
import SelectRoom from '_vc/select-room'
import TagStatus from '_vc/tag-status'
import ChargeDetails from '_v/components/charge-details'

import { contractList, contractLiquidationDetail } from '@/api/contract'
import { queryUserName } from '@/api/sys-user'

export default {
    name: 'c-history-list',
    mixins: [mContractList],
    components: { SelectRoom, TagStatus, ChargeDetails },
    data() {
        return {
            mtHeight: 360,
            loading: false,
            loadingExport: false,
            curId: '',
            page: {
                total: 0,
                list: [],
            },
            remark: '', // 清算备注
            chargeDetails: [], // 清算明细
            modal: {
                showChargeDetails: false,
            },
            dict: {
                feeType: Dict.NULL,
                migrateType: Dict.NULL,
                contractStatus: Dict.NULL,
            },
            contractStatusList: [],
        }
    },
    computed: {
        ...mapCache({
            filter: 'historyFilter',
            advFilter: 'historyAdvFilter',
            advOptions: 'historyAdvOptions',
            selectRoom: 'historySelectRoom',
        }),

        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 70,
                },
                {
                    key: 'houseName',
                    title: '房源名称',
                    align: 'left',
                    minWidth: 200,
                    ellipsis: true,
                    tooltip: true,
                },
                {
                    key: 'cusName',
                    title: '客户姓名',
                    align: 'left',
                    minWidth: 150,
                    tooltip: true,
                },
                {
                    key: 'cusMobile',
                    title: '客户手机号',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    key: 'comName',
                    title: '单位名称',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
                {
                    key: 'changeDate',
                    title: '退租日期',
                    align: 'center',
                    minWidth: 160,
                },
                {
                    key: 'contractStatusText',
                    title: '租约状态',
                    align: 'center',
                    minWidth: 160,
                    slot: 'contractStatusText',
                },
                {
                    key: 'date',
                    title: '合同起止',
                    align: 'center',
                    width: 200,
                },
                {
                    key: 'rent',
                    title: '租金(元/月)',
                    align: 'right',
                    minWidth: 120,
                },
                {
                    key: 'migrateTypeText',
                    title: '地址迁移',
                    align: 'center',
                    minWidth: 120,
                    slot: 'migrateTypeText',
                },
                {
                    key: 'signUser',
                    title: '签约人',
                    align: 'center',
                    width: 100,
                },
                {
                    key: 'updateTime',
                    title: '操作时间',
                    align: 'center',
                    width: 150,
                    render: pipeCell('ymdL'),
                },
                {
                    key: 'updateUserName',
                    title: '操作人',
                    align: 'left',
                    width: 120,
                },
                {
                    title: '操作',
                    align: 'center',
                    width: 160,
                    slot: 'action',
                    fixed: 'right',
                },
            ]
        },
    },
    created() {
        this.fetch()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
    methods: {
        fetch() {
            this.loading = true

            Promise.all([
                Dict.get(['migrate_type', 'contract_status', 'fee_type']),
                queryUserName(),
                contractList(
                    Object.assign(
                        {},
                        this.filter,
                        this.normalizeAdvFilter(this.advFilter)
                    )
                ),
            ])
                .then((args) => {
                    var [dictGroup, users, view] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    if (users) {
                        this.userNameMap = this.normalizeUserName(users.data)
                    }

                    this.page.list = this.normalizePageData(view.data.page.list)
                    this.page.total = parseInt(view.data.page.totalCount)

                    const contractStatusList = []
                    this.dict.contractStatus.toList().forEach((v) => {
                        v.remark = JSON.safeParse(v.remark)
                        if (v.remark.status === '0') {
                            contractStatusList.push(v)
                        }
                    })
                    this.contractStatusList = contractStatusList
                })
                .finally(() => {
                    this.loading = false
                })
        },
        search() {
            this.filter.pageNo = 1
            if (!this.filter.contractStatus) {
                this.filter.contractStatus = '7,8,9,21,22,23,24,25,26'
            }
            this.fetch()
        },
        normalizePageData(list) {
            const contractStatusDict = this.dict.contractStatus
            const migrateTypeDict = this.dict.migrateType

            list.forEach((v) => {
                v.date = `${v.startDate} 至 ${v.endDate}`
                v.rent = currency(v.rent / 100)
                v.showOtherHandler = v.contractStatus !== '2'

                const migrate = migrateTypeDict.get(v.migrate)
                if (migrate) {
                    v.migrateTypeText = migrate.text
                    v.migrateTypeColor = JSON.safeParse(migrate.remark).color
                    v.migrateTypeBgc = JSON.safeParse(migrate.remark).background
                }

                const status = contractStatusDict.get(v.contractStatus)
                v.contractStatusText = status?.text
                v.contractStatusColor = JSON.safeParse(status?.remark)?.color
                v.contractStatusBgc = JSON.safeParse(status?.remark)?.background
                v.houseName = v.houseName.split('(')[0]
                v.updateUserName = this.userNameMap[v.updateUserId] || ''
                v.isLiquation = this.checkLiquation(v)
            })

            return list
        },
        // 选择房源
        onSelectRoom(value, options) {
            var houseIds = [],
                floorNumId = []

            options.forEach((v) => {
                if (v.houseId) {
                    houseIds.push(v.houseId)
                } else {
                    floorNumId.push(`${v.parkId}_${v.floorId}_${v.floorNum}`)
                }
            })

            Object.assign(this.filter, {
                houseIds: houseIds.join(','),
                floorNumId: floorNumId.join(','),
            })

            this.search()
        },
        // 合同录入
        onClickAdd(e) {
            this.$router.push({
                name: 'contractCreate',
                query: { from: 'contractIndex' },
            })
        },
        // 导出Excel
        onClickExport() {
            this.loadingExport = true

            contractList(
                Object.assign(
                    {},
                    this.filter,
                    this.normalizeAdvFilter(this.advFilter),
                    {
                        pageNo: 1,
                        pageSize: -1,
                    }
                )
            )
                .then((res) => {
                    var $mt = this.$refs.mt
                    $mt.exportToExcel({
                        rows: this.normalizePageData(res.data.page.list),
                    })
                })
                .finally(() => {
                    this.loadingExport = false
                })
        },
        // 合同详情
        rowClickInfo(row) {
            this.$router.push({
                name: 'contractViewIndex',
                query: { contractId: row.id, type: '5' },
            })
        },
        // 清算明细
        rowClickLiquidationDetail(row) {
            contractLiquidationDetail(row.id)
                .then((res) => {
                    const { remark, chargeDetails } = this.normalizeLiquidation(
                        res.data
                    )
                    this.remark = remark
                    this.chargeDetails = chargeDetails
                })
                .finally(() => {
                    this.modal.showChargeDetails = true
                })
        },
    },
}
</script>
<style lang="less" scoped></style>
